// OrderSummary.jsx
import React from "react";

const OrderSummary = ({ subscriptionData }) => {
  //  Calculation of Price
  const base_Price = subscriptionData?.price; // Base price of the subscription plan
  const plan_Duration = subscriptionData.duration; // Duration of the subscription plan
  const base_gst = 18; // GST rate in percentage

  // Calculate the total price for the given duration
  const total_Price_Before_Gst = base_Price * plan_Duration;

  // Calculate the GST amount
  const plan_Gst = (total_Price_Before_Gst * base_gst) / 100;

  // Calculate the final total price including GST
  const total_Price = total_Price_Before_Gst + plan_Gst;

  //Stipe Integer Pricing

  const strip_Price = total_Price * 100;

  console.log("Total Price Including Gst:", total_Price);

  // End
  const monthlyprice = 30; // Ensure price is a number
  const freeMonths = parseInt(subscriptionData?.freeMonths);
  return (
    <aside className="lg:sticky lg:top-6">
      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
        <div className="border-b border-gray-200 bg-gray-50 px-6 py-5">
          <p className="text-sm font-semibold uppercase tracking-[0.14em] text-purple-600">
            Your order
          </p>
          <h2 className="mt-2 text-2xl font-bold text-gray-950">
            Order summary
          </h2>
        </div>

        <div className="space-y-5 px-6 py-6">
          <div className="rounded-lg border border-purple-100 bg-purple-50/60 p-4">
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="text-base font-semibold text-gray-950">
                  {subscriptionData.promotion?.match(/\d+/)?.[0]
                    ? `${
                        plan_Duration -
                        Number(subscriptionData.promotion.match(/\d+/)[0])
                      } Months`
                    : `${plan_Duration} Months`}{" "}
                  Plan ({subscriptionData.title})
                </p>
                <p className="mt-1 text-sm font-medium text-purple-700">
                  Save {subscriptionData?.savings}%
                </p>
              </div>
              <div className="text-right">
                <p className="text-sm text-gray-400 line-through">
                  ${total_Price_Before_Gst * plan_Duration}
                </p>
                <p className="text-xl font-bold text-purple-700">
                  ${total_Price_Before_Gst}
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-4 text-sm">
            <div className="flex items-start justify-between gap-4 border-b border-gray-100 pb-4">
              <div>
                <p className="font-semibold text-gray-900">
                  + {subscriptionData.promotion}
                </p>
                <p className="mt-1 text-xs font-semibold uppercase tracking-[0.12em] text-gray-400">
                  SPECIALDEAL
                </p>
              </div>
              <div className="text-right">
                <p className="text-gray-400 line-through">
                  ${monthlyprice * freeMonths}
                </p>
                <p className="font-semibold text-gray-600">$0.00</p>
              </div>
            </div>

            <div className="flex items-center justify-between border-b border-gray-100 pb-4">
              <p className="font-semibold text-gray-900">Tax</p>
              <p className="font-semibold text-gray-700">${plan_Gst}</p>
            </div>
          </div>

          <div className="rounded-lg border border-gray-200 bg-white px-5 py-4 shadow-sm">
            <div className="flex items-center justify-between gap-4">
              <h3 className="text-base font-semibold text-gray-950">
                Order total
              </h3>
              <p className="text-2xl font-bold text-purple-700">
                ${total_Price}
              </p>
            </div>
            <p className="mt-2 text-xs leading-5 text-gray-500">
              Includes selected plan duration, active promotion, and tax.
            </p>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default OrderSummary;
